import React, { useEffect } from "react";
// MUI
import { ThemeProvider } from "@mui/material";

// Providers n Actions
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";

import { store, persistor } from "./store/store";

import { SnackbarProvider } from "notistack";

// Routes
import { Routes } from "./Routes";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { onMessage } from "firebase/messaging";
import { messaging } from "./Utils/FirebaseConfig";
// import { RequestNotificationPermission } from "./Utils/RequestNotificationPermission";

// Assets
import "./STYLES/main.css";
import ScrollToTop from "./ScrollToTop";
import Theme from "./STYLES/Theme";
import ErrorAlert from "./Components/Alert/ErrorAlert";

import WarningAlert from "./Components/Alert/WarningAlert";
import SuccessAlert from "./Components/Alert/SuccessAlert";
import ShareEarn from "./Components/Common/ShareEarn";
import NetworkStatusProvider from "./Components/NetworkStatusProvider";
import SessionExpiredModal from "./Components/Common/SessionExpiredModal";
import { useFirebaseNotification } from "./Hooks/useFirebaseNotification";
import AuthModal from "./Pages/Auth/auth-modal";
import { ProfileProvider } from "./Utils/ProfileContext";

function App() {
  useEffect(() => {
    onMessage(messaging, (payload) => {
    

      // Show notification manually
      if (Notification.permission === "granted") {
        const { title, body } = payload.notification;
        new Notification(title, {
          body,
          icon: "/logo192.png",
        });
      }
    });
  }, []);

  useFirebaseNotification();

  return (
    <>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ThemeProvider theme={Theme}>
            <SnackbarProvider
              maxSnack={3}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              Components={{
                error: ErrorAlert,
                success: SuccessAlert,
                warning: WarningAlert,
              }}
            >
              <NetworkStatusProvider>
                <ProfileProvider>
                  <SessionExpiredModal />
                  <ScrollToTop />
                  <AuthModal />
                  <Routes />
                </ProfileProvider>
              </NetworkStatusProvider>
            </SnackbarProvider>
          </ThemeProvider>
        </PersistGate>
      </Provider>
    </>
  );
}

export default App;
